module.exports = __webpack_public_path__ + "static/media/swp-1.dfb63960.png";